export class RoleMappingDTO {
    roleId: number;
    roleName: string;
    mappedRoles: string[] = [];
    mappedGroups: string[] = [];

    constructor(data?: Partial<RoleMappingDTO>) {
        if (data) {
            this.bindData(data);
        }
    }

    bindData(data: Partial<RoleMappingDTO>): void {
        if (data) {
            this.roleId = data.roleId || 0;
            this.roleName = data.roleName || '';
            this.mappedRoles = data.mappedRoles || [];
            this.mappedGroups = data.mappedGroups || [];
        }
    }

    addRoleMapping(role: string) {
        if (!this.mappedRoles.includes(role)) {
            this.mappedRoles.push(role);
            return true;
        }
        return false;
    }

    removeRoleMapping(role: string) {
        const index = this.mappedRoles.indexOf(role);
        if (index > -1) {
            this.mappedRoles.splice(index, 1);
            return true;
        }
        return false;
    }

    addGroupMapping(group: string) {
        if (!this.mappedGroups.includes(group)) {
            this.mappedGroups.push(group);
            return true;
        }
        return false;
    }

    removeGroupMapping(group: string) {
        const index = this.mappedGroups.indexOf(group);
        if (index > -1) {
            this.mappedGroups.splice(index, 1);
            return true;
        }
        return false;
    }
} 